import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faBuilding, 
  faDraftingCompass, 
  faPencilRuler, 
  faCubes,
  faHome,
  faCity
} from '@fortawesome/free-solid-svg-icons';
import '../../styles/ServicePage.css';

const ArchitekturPage: React.FC = () => {
  return (
    <div className="service-page">
      {/* Header Section */}
      <header className="service-header">
        <div className="container">
          <div className="service-header-content">
            <div className="service-icon">
              <FontAwesomeIcon icon={faBuilding} />
            </div>
            <h1>Architektur</h1>
            <p>
              Professionelle Architekturplanung für Ihr Bauprojekt
            </p>
          </div>
        </div>
      </header>

      <div className="service-content">
        <div className="container">
          {/* Introduction Section */}
          <section className="service-section">
            <h2 className="service-section-title">Architekturplanung</h2>
            <p>
              Im Bereich Architektur bietet das Ingenieurbüro Neubaur umfassende Planungsleistungen für Bauprojekte 
              aller Art. Wir verbinden ästhetisches Design mit funktionaler Planung und berücksichtigen dabei 
              technische, wirtschaftliche und ökologische Aspekte.
            </p>
            <p>
              Unser Leistungsspektrum umfasst sowohl Neubauten als auch Sanierungen und Umbauten bestehender Gebäude. 
              Dabei legen wir besonderen Wert auf nachhaltige und energieeffiziente Bauweisen sowie auf die 
              Integration moderner Gebäudetechnik.
            </p>
          </section>

          {/* Features Section */}
          <section className="service-section">
            <h2 className="service-section-title">Unsere Leistungen im Bereich Architektur</h2>
            <div className="service-features">
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faDraftingCompass} />
                </div>
                <h3 className="service-feature-title">Entwurfsplanung</h3>
                <p className="service-feature-text">
                  Entwicklung kreativer und funktionaler Entwürfe für Ihr Bauprojekt.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faPencilRuler} />
                </div>
                <h3 className="service-feature-title">Ausführungsplanung</h3>
                <p className="service-feature-text">
                  Erstellung detaillierter Ausführungspläne für die Realisierung Ihres Projekts.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faCubes} />
                </div>
                <h3 className="service-feature-title">3D-Visualisierung</h3>
                <p className="service-feature-text">
                  Erstellung von 3D-Modellen und Visualisierungen für eine bessere Vorstellung des Projekts.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faHome} />
                </div>
                <h3 className="service-feature-title">Sanierung und Umbau</h3>
                <p className="service-feature-text">
                  Planung von Sanierungen und Umbauten bestehender Gebäude unter Berücksichtigung des Bestands.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faCity} />
                </div>
                <h3 className="service-feature-title">Denkmalschutz</h3>
                <p className="service-feature-text">
                  Behutsame Planung von Maßnahmen an denkmalgeschützten Gebäuden.
                </p>
              </div>
              
              <div className="service-feature">
                <div className="service-feature-icon">
                  <FontAwesomeIcon icon={faBuilding} />
                </div>
                <h3 className="service-feature-title">Bauleitung</h3>
                <p className="service-feature-text">
                  Überwachung der Bauausführung und Koordination der beteiligten Gewerke.
                </p>
              </div>
            </div>
          </section>

          {/* Process Section */}
          <section className="service-section">
            <h2 className="service-section-title">Unser Planungsprozess</h2>
            <div className="service-process">
              <div className="process-step">
                <div className="process-number">1</div>
                <div className="process-content">
                  <h3 className="process-title">Bedarfsanalyse</h3>
                  <p className="process-text">
                    Wir ermitteln Ihre Wünsche und Anforderungen und analysieren die Rahmenbedingungen des Projekts.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">2</div>
                <div className="process-content">
                  <h3 className="process-title">Vorentwurf</h3>
                  <p className="process-text">
                    Wir entwickeln erste Entwurfsideen und stimmen diese mit Ihnen ab.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">3</div>
                <div className="process-content">
                  <h3 className="process-title">Entwurfsplanung</h3>
                  <p className="process-text">
                    Auf Basis des abgestimmten Vorentwurfs erstellen wir detaillierte Entwurfspläne.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">4</div>
                <div className="process-content">
                  <h3 className="process-title">Genehmigungsplanung</h3>
                  <p className="process-text">
                    Wir erstellen die für die Baugenehmigung erforderlichen Unterlagen und begleiten das Genehmigungsverfahren.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">5</div>
                <div className="process-content">
                  <h3 className="process-title">Ausführungsplanung</h3>
                  <p className="process-text">
                    Wir erstellen detaillierte Ausführungspläne für die Realisierung des Projekts.
                  </p>
                </div>
              </div>
              
              <div className="process-step">
                <div className="process-number">6</div>
                <div className="process-content">
                  <h3 className="process-title">Bauüberwachung</h3>
                  <p className="process-text">
                    Während der Bauphase überwachen wir die fachgerechte Ausführung und koordinieren die beteiligten Gewerke.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* CTA Section */}
          <section className="service-cta">
            <h2 className="service-cta-title">Ihr Projekt in guten Händen</h2>
            <p className="service-cta-text">
              Nutzen Sie unsere Expertise im Bereich Architektur für Ihr nächstes Bauprojekt. 
              Wir beraten Sie gerne zu Ihren Möglichkeiten und entwickeln gemeinsam mit Ihnen die optimale Lösung.
            </p>
            <Link to="/kontakt" className="btn btn-primary">
              Kontakt aufnehmen
            </Link>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ArchitekturPage;
